import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { PageToolBar } from './PageToolBar';
import { PageViewer } from './PageViewer';
import { PageLeftPane } from './PageLeftPane';
import { TagList } from '../tag/TagList';
import {
	PageItem,
    //addPages,
    //AddNotesAction,
  	selectPages,
} from './pageSlice';

export function PageBrowser() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	console.log('is mobile in browser?' + isMobile);
	const viewStyle = {
		height: `calc(100%)`,
		//height: `calc(100% - 44px)`,
		//height: '100%r',
		//backgroundColor: 'purple',
	};
	const mainStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		//backgroundColor: 'pink',
	};
	const contentStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		//overflow: 'auto',
		display: 'flex',
		//backgroundColor: 'grey',
	};
	const colOneStyle = {
		height: '100%',
		flexGrow: 1,
		width: '20%',
		//backgroundColor: 'blue',
	};
	const colTwoStyle = {
		height: '100%',
		flexGrow: 5,
		//backgroundColor: 'y ellow',
		width: '80%',
	};

	const dispatch = useAppDispatch();
	const leftPaneOpen = true;

	return (
		<Box sx={viewStyle}>
			<Box sx={mainStyle}>
				{
					isMobile
						?
							(
								<Box sx={contentStyle}>
									<Box sx={colTwoStyle}>
										<Outlet />
									</Box>
								</Box>
						)
						:
							(
								<Box sx={contentStyle}>
									<Box sx={colOneStyle}>
										<PageLeftPane />
									</Box>
									<Box sx={colTwoStyle}>
										<Outlet />
									</Box>
								</Box>
						)
				}
			</Box>
		</Box>
	);
}
